<template>
    <div>

    </div>
</template>

<script>
    import apiUrl from "@/utils/UrlApi"

    export default {
        name: "checkWechat",
        computed: {
            quary: {
                get() {
                    return this.$route.query
                }
            },
            userName: {
                get() {
                    return this.$store.getters.getUserName;
                },
                set(val) {
                    this.$store.commit("updateUserName", val);
                }
            },
            userType: {
                get() {
                    return this.$store.state.userType;
                },
                set(val) {
                    this.$store.commit("updateUserType", val);
                }
            },
            gpsState: {
                get() {
                    return this.$store.state.gpsState;
                },
                set(val) {
                    this.$store.commit('updateGpsState', val);
                }
            }
        },
        methods: {

            checkWeChat() {
                let self = this
                // let data = `code=${this.quary.code}&state=${this.quary.state}`;
                let data = this.quary;

                this.$http.get(apiUrl.wxLogin, {
                    params: data
                }).then(res => {
                    // console.log(res)
                    if (res.data.code === '200') {
                        localStorage.setItem('token', res.data.data.data.token)
                        localStorage.setItem('userName', res.data.data.data.userInfo.name)
                        localStorage.setItem('userId', res.data.data.data.userInfo.userId)
                        // localStorage.setItem('userType', res.data.data.data.userInfo.type)

                        self.userName = res.data.data.data.userInfo.name
                        // self.userType = res.data.data.data.userInfo.type
                        // self.$router.replace({
                        //     name: 'AirQuality'
                        // })
                        self.getUserInfo()

                    } else {
                        self.$message.error("登录失败");
                        setTimeout(()=>{
                            this.$router.replace({
                                name:'login'
                            })
                        })
                    }
                })
            },

            getUserInfo() {
                let url = apiUrl.GetUserInfo
                let self = this
                this.$http.get(url, {
                    params: {}
                }).then(res => {
                    // console.log(res)
                    window.localStorage.setItem('gpsState', JSON.stringify(res.data.data))
                    this.userType = res.data.data.type
                    this.gpsState = {
                        area: res.data.data.area,
                        city: res.data.data.city,
                        cityCode: res.data.data.cityCode
                    }
                    self.$router.replace({
                        name: 'systemSelection'
                    })

                })
            },
        },
        mounted() {
            this.checkWeChat()
        }
    }

</script>

<style scoped>

</style>